export const SHARE_ACCOUNT_DATA='SHARE_ACCOUNT_DATA';
export const SHARE_ACCOUNT_TOTAL_DATA='SHARE_ACCOUNT_TOTAL_DATA';